import { ModifiedQueryData } from '@models';
import { searchService } from '@services';
import { BaseComponent } from '../base.component';
import defaultHtml from './modified-query.component.hbs';

export class ModifiedQueryComponent extends BaseComponent<ModifiedQueryData> {
    protected override bindEvent = 'hawksearch:bind-modified-query';
    protected override customTemplatePropertyName = 'modifiedQuery';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data || !this.data.display || !this.data.query || !this.data.modifiedQuery) {
            return '';
        }

        const html = template({
            query: this.data.query,
            modifiedQuery: this.data.modifiedQuery
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-query]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLElement;
                const query = element.getAttribute('hawksearch-query');

                if (query) {
                    searchService.query(query, true);
                }
            });
        });
    }
}
